import { useMemo, useState } from "react";
import { useScreenClass } from "react-grid-system";
import MinimalSelect from "./MinimalSelect";

type Props = {
  startMonth: string;
  setStartMonth: any;
  endMonth: string;
  setEndMonth: any;
};
export const StartSelect = (props: Props) => {
  const { startMonth, setStartMonth, endMonth } = props;
  const screenClass = useScreenClass();
  const isMobile = useMemo(
    () => ["xs", "sm"].includes(screenClass),
    [screenClass]
  );
  
  const getLastThreeMonths = () => {
    const today = new Date();
    const months = [];
    for (let i = 0; i < 3; i++) {
      const year = today.getFullYear();
      const month = today.getMonth() + 1;
      const label = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
      }).format(today);
      today.setDate(1); // Set the day of the month to 1
      const value = `${year}-${month.toString().padStart(2, "0")}-01`;
      months.push({ label, value });
      // Move to the previous month
      today.setMonth(today.getMonth() - 1);
    }
    return months;
  };

  const lastThreeMonths = getLastThreeMonths();

  // Filter options based on endMonth
  const filteredOptions = lastThreeMonths.filter(option => new Date(option.value) <= new Date(endMonth));

  return (
    <>
      <MinimalSelect
        setClass={isMobile ? "rs-container" : ""}
        placeholder="Select Start Month"
        options={filteredOptions}
        value={filteredOptions?.find(option => option.value === startMonth)}
        onChange={(data: any) => {
          setStartMonth(data.value);
          // Optionally clear or adjust the endMonth if it becomes invalid
        }}
      />
    </>
  );
};

export const EndSelect = (props: Props) => {
  const { endMonth, setEndMonth, startMonth } = props;
  const screenClass = useScreenClass();
  const isMobile = useMemo(
    () => ["xs", "sm"].includes(screenClass),
    [screenClass]
  );

  const getLastThreeMonthsLastDays = () => {
    const today = new Date();
    const lastDays = [];

    for (let i = 0; i < 3; i++) {
      const year = today.getFullYear();
      const month = today.getMonth() + 1;
      const lastDay = new Date(year, month, 0).getDate();
      const label = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
      }).format(today);
      today.setDate(1);
      const value = `${year}-${month.toString().padStart(2, "0")}-${lastDay
        .toString()
        .padStart(2, "0")}`;

      lastDays.push({ label, value });

      today.setMonth(today.getMonth() - 1);
    }

    return lastDays;
  };

  const lastThreeMonths = getLastThreeMonthsLastDays();

  // Filter options based on startMonth
  const filteredOptions = lastThreeMonths.filter(option => new Date(option.value) >= new Date(startMonth));

  return (
    <>
      <MinimalSelect
        setClass={isMobile ? "rs-container" : ""}
        placeholder="Select End Month"
        options={filteredOptions}
        value={filteredOptions?.find(option => option.value === endMonth)}
        onChange={(data: any) => {
          setEndMonth(data.value);
        }}
      />
    </>
  );
};